// extracted by mini-css-extract-plugin
export default {"expandableChip":"expandableChip_expandableChip__+wYRY","expanded":"expandableChip_expanded__3Pw5m"};